<template>
    
    <div>

		<section 
			:class="{'outer-pad': !is.public }"
		>

			<form :class="{form:true, normal:true, full:true, public:is.public}">

				<div :class="{'form-inputs-section': true, full: true, panel: true, 'analysis-credits': true, tabbed: true, 'selected-tab': selectedTab === 'analysis' }" v-if="analysisCreditsInfoLoaded">

					<h2 class="form-inputs-section-title tab-right" @click="selectedTab = 'analysis'">Analysis Credits <span class="whats-this" @click="showAnalysisCreditsInfo">What's this?</span></h2>

					<div class="form-inputs-section-inner" v-if="!analysisCreditsAllowed">

						<p>Analysis credits are required to use the <strong>Content &amp; Keywords</strong> area, this is available on the <strong>{{levelName[2]}}</strong> plans. <span v-if="trialing">You can upgrade your free trial to the Pioneer 500 package and get free access for upto 14 days.</span></p>

						<span class="video" @click="watchVideo">
							<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
							viewBox="0 0 117.1 95.15" style="enable-background:new 0 0 117.1 95.15;" xml:space="preserve">
							<path style="fill:#F95930;" class="st" d="M99.72,6.1H19.38c-7.23,0-13.11,5.88-13.11,13.11v56.74c0,7.23,5.88,13.11,13.11,13.11h80.33
							c7.23,0,13.11-5.88,13.11-13.11V19.21C112.82,11.98,106.94,6.1,99.72,6.1z M47.64,63.46V31.69l25.74,15.89L47.64,63.46z"/>
							</svg>
							<span class="label">Watch a video about Content &amp; Keywords</span>
						</span>

					</div>

					<div class="form-inputs-section-inner" v-if="analysisCreditsAllowed">

						<div class="overview">

							<span class="large-button flip-colours no-hover mini">Total Credits: {{analysisCredits}}</span>

							<span class="large-button mini" @click="buyAnalysisCredits">Buy More</span>

						</div>

						<AnalysisCreditsPurchases
							:totals="analysisCreditsInfo"
						/>

					</div>

				</div>

				<div :class="{'form-inputs-section': true,  full: true, panel: true, 'keyword-subscriptions': true, tabbed: !!analysisCreditsInfoLoaded, 'selected-tab': selectedTab === 'subscriptions' }">

					<h2 class="form-inputs-section-title" @click="selectedTab = 'subscriptions'">Packages</h2>

					<div class="form-inputs-section-inner">

						<div class="new-user-panel">

							<p v-if="is.keywords.has&&!is.trialing" class="current-info">Your current <span class="orange" v-html="currentProductName" /> subscription allows for <span class="orange">{{numberWithCommas(currentCount)}} Keywords</span> per day<span v-if="legacy"> (this is a legacy plan, you will remain on this plan until you upgrade, downgrade or cancel your subscription)</span>. It's a {{currentSubscription}}ly subscription<span v-if="!is.stripe.trial"> and the current {{currentSubscription}} ends <span class="orange" v-html="endDate" /></span><span v-if="is.stripe.trial"> and you are currently on your free trial which ends <span class="orange" v-html="endDate" /></span><span v-if="nextProductName">. After this your subscription will be downgraded to <span class="orange" v-html="nextProductName" /></span><span v-if="is.stripe.cancelled"> (you have selected to cancel your subscription after this date)</span>.</p>

							<p class="current-info" v-if="is.trialing">You are currently on the <span class="orange" v-html="currentProductName" /> <span class="orange">free trial</span> which ends <span class="orange" v-html="endDate" />. <strong>Please remember to <span @click="processPrice" class="underline cursor">enter your card details</span> before the trial is over to avoid losing data.</strong> Your card will not be charged until your trial is over. You can cancel at any time before then and will not be charged.</p>

							<p class="current-info" v-if="is.user.new && selected[level].keywords>500">For upgrades to <span class="orange">1000+ keyword packages</span>, payment will be taken immediately.</p>

						</div>

						<p id="response-msg" v-if="responseMsgProcessed!==''" :class="{'past-due':is.stripe.pastDue}" @click="sortPastDue">
							<span v-html="responseMsgProcessed" />
							<span class="close" @click="closeResponseMsg" v-if="!is.stripe.pastDue">X</span>
						</p>

						<div class="keyword-subscriptions-options-wrap-wrap">

							<div class="keyword-subscriptions-options-levels">

								<div @click="level=1;++slideBarKey" :class="{ selected: level === 1 }">
									<span class="current" v-if="current.level===1">Current</span>
									<h2 v-html="levelName[1]" />
									<p>• Rank Tracking &nbsp; • Unlimited Users &amp; Projects &nbsp; <br>• Data Dive &nbsp; • Tasks / Investigations &nbsp; • Flexible Alerts</p>
								</div>

								<div @click="level=2;++slideBarKey" :class="{ selected: level === 2 }">
									<span class="current" v-if="current.level===2">Current</span>
									<span class="current" v-if="current.level===1&&trialing">Free Trial Available</span>
									<h2 v-html="levelName[2]" />
									<p>Everything in {{levelName[1]}} plus • Content &amp; Keywords</p>
								</div>

								<div class="custom" @click="custom">
									<h2>Custom</h2>
									<p>Need more or something a bit different? <br>Click to get in touch.</p>
								</div>

							</div>

							<div class="keyword-subscriptions-options-wrap">

								<div class="slide-wrap mobile">

									<VueSlideBar 
										v-if="slider.data.length>0"
										v-model="keywordCount[level]" 
										:data="slider.data"
										:range="slider.rangeMobile"
										:processStyle="{ backgroundColor: '#f1492a' }"
										:tooltipStyles="{ backgroundColor: '#f1492a', borderColor: '#f1492a' }"  
										@callbackRange="callbackRange"
										:key="slideBarKey"
									>
										<template slot="tooltip" slot-scope="tooltip">
											<img :src="recImage">
										</template>
									</VueSlideBar>

								</div>

								<div class="slide-wrap desktop">

									<VueSlideBar 
										v-if="slider.data.length>0"
										v-model="keywordCount[level]"
										:data="slider.data"
										:range="slider.range" 
										:paddingless="true"
										:processStyle="{ backgroundColor: '#f1492a' }"
										:tooltipStyles="{ backgroundColor: '#f1492a', borderColor: '#f1492a' }"  
										@callbackRange="callbackRange"
										:key="slideBarKey"
									>
										<template slot="tooltip" slot-scope="tooltip">
											<img :src="recImage">
										</template>
									</VueSlideBar>

								</div>

								<h2 class="selected-label" v-if="selected!==null">
									{{selectedLabel}} 
									<span class="current" v-if="is.keywords.currentSelected"> - Current</span> 
									<span class="frequency-info">{{selectedLabelWeekly}} keywords checked weekly / {{selectedLabelMonthly}} checked monthly</span>
								</h2>

								<div 
									:class="{selected:true}" 
									v-if="selected!==null&&fetchedSettings"
								><div :class="{options:true,hasButton:(showSubscribeButton||is.public)}"><div :class="{ disabled: ( ( currentSubscription === 'month' && is.keywords.currentSelected ) || currentSubscription === 'year' ) && !is.trialing, option: true, selected: selectedFrequency === 'month', legacy: legacy, pulseIt: !selectedFrequency && pulseFrequencies, disabled2: currentSubscription === 'year' && !is.trialing }" @click="selectFrequency ('month')">

										<h3 class="info-title">Billed Monthly</h3>

										<h4 class="info-price" v-html="price('month').cost" />

										<h5 class="info-price-info" v-html="price('month').text" />

									</div><div :class="{ trialing: is.trialing, disabled: currentSubscription === 'year' && is.keywords.currentSelected && !is.trialing, yearly: true, option: true, selected: selectedFrequency === 'year', legacy: legacy, pulseIt: !selectedFrequency && pulseFrequencies }" @click="selectFrequency ('year')">

										<h3 class="info-title">Billed Yearly</h3>

										<h4 class="info-price" v-html="price('year').year" />

										<h5 class="info-price-info" v-html="price('year').text" />

									</div><span :class="{'large-button':true,dropText:noChargeUntilAfterTrial}" @click="processPrice" v-html="subscribeBtn" v-if="showSubscribeButton" /><a href="https://app.rankcaddy.io/create-account" target="_parent" :class="{'large-button':true}" v-html="subscribeBtn" v-if="is.public" /></div>
								</div>

								<div class="cancel-panel" v-if="subscriptionAndCardDetailsEntered">

									<span v-if="canReverseOrCancel" class="large-button" @click="cancel" v-html="is.stripe.cancelled?'Reverse Cancellation':'Cancel Your Subscription'" />

									<p v-if="is.stripe.cancelled">You cancelled your subscription on {{cancelledDate}}, it will end on {{cancelDate}}.</p>

									<p v-if="!is.stripe.cancelled&&!is.stripe.trial">When cancelling, your account will continue to be active until the end of the current subscription period.</p>

									<p v-if="!is.stripe.cancelled&&is.stripe.trial&&currentInfo.keywords===250">Cancelling will mean your card will not be charged at the end of your trial, your trial will continue until {{endDate}}.</p>

									<p v-if="!is.stripe.cancelled&&is.stripe.trial&&currentInfo.keywords>250">Cancelling will mean your card will not be charged at the end of your trial, your package will be reduced to Pathfinder 250 and your trial will continue until {{endDate}}.</p>

								</div>

							</div>

						</div>

					</div>

				</div>

			</form>

		</section>

		<Payment 
			v-if="paymentInfo||intent" 
			:paymentInfo="paymentInfo||{}" 
			:setPaymentMethod="paymentMethod"
			:title="paymentTitle"
			:frequency="paymentFrequency"
			:amount="amount"
			@close-payment="closePayment"
			:trial="trial"
			:intent="intent"
			:retryIntent="retryIntent"
			:requireAddress="true"
			trialText="You can cancel before the end of your trial and you will not be charged." 
			stripeTextColour="#394559"
		/>

    </div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import general from './../../utils/general'
import ApiService from './../../services/api.service'
import Payment from './../../components/Payment.vue'
import FormInput from './../../components/Form/Input.vue'
import AnalysisCreditsPurchases from './../../components/AnalysisCreditsPurchases.vue'
import VueSlideBar from 'vue-slide-bar' // https://github.com/biigpongsatorn/vue-slide-bar
import VueScrollTo from 'vue-scrollto';
export default {
  	name: 'Subscriptions',
  	components: {
	    Payment,
	    FormInput,
	    VueSlideBar,
		AnalysisCreditsPurchases
	  },
  	props: {
		isPublic: {
			type: Boolean,
			default: false
		}
	},
  	data() {

		return {
			newUser: false,
			paymentInfo:false,
			paymentTitle:null,
			paymentMethod: null,
			paymentFrequency: null,
			lastWebhookUpdateCheckCount: null,
			legacy: false,
			selected: {
				1: {
					keywords: 0
				},
				2: {
					keywords: 0
				}
			},
			currentPrice: null,
			keywordCount: {
				1: 250,
				2: 500
			},
			amount:0,
			currentInfo: {},
			responseMsg: '',
			lastWebhookUpdate: {},
			lastWebhookUpdateCheck: {},
			loadUserCount: 0,
			stripe: {},
			selectedFrequency: 'month',
			firstLoadUser: true,
			intent: null,
			retryIntent: false,
			paymentCloseEvents: {},
			pulseFrequencies: false,
			fetchedSettings: false,
			currency: null,
			trial: false,
			trialing: false,
			firstTime: false,
			firstName: '',
			level: 1,
			levels: [1,2],
			selectedTab: 'subscriptions',
			slideBarKey: 0,
			trialExpires: null,
			levelName: {
				1: 'Pathfinder',
				2: 'Pioneer'
			}
		}

	},
	watch: {
        products: {
			deep: true,
			handler(to, from) {

				this.prep ();

			}
        },
		$route: {
			immediate: true,
			deep: true,
			handler( to, from ) {
				
				if ( ( to.path === '/account/subscriptions/' || to.path === '/account/subscriptions' ) && to.hash === '#pioneer' ) {

					setTimeout( function () { this.level = 2; }.bind(this), 150 );

				}

				this.prep ();

			}
		}
	},
	computed: {

		...mapState('general',['products','analysisCreditsInfo','analysisCreditsAccess','analysisCredits','analysisCreditsInfoLoaded']),

		recImage () {

			return require('./../../assets/img/rectangle-slider.svg');

		},

		analysisCreditsAllowed () {

			if ( this.current.level === 2 ) return true;

			if ( !!this.analysisCreditsAccess.keywords || !!this.analysisCreditsAccess.domains ) {

				return this.analysisCredits > 0;

			}

			return false;

		},

		current() {

			let c = {
				level: 0,
				keywords: 0,
				stripe: {
					subscriptionStatus: null,
					cancelled: null,
					subscriptionStatus: null
				}
			};

			if ( !!this.stripe && Object.keys( this.stripe ).length > 0 ) {

				Object.keys( c.stripe ).forEach( function (s) {

					if ( this.stripe[s] ) c.stripe[s] = this.stripe[s];

				}.bind(this));

			}

			if ( Object.keys( this.currentInfo ).length > 0 ) {

				c.level = 1;

				if ( this.currentInfo.level ) {

					let level = this.currentInfo.level;

					if ( this.currentInfo.levelOverride ) {

						level = this.currentInfo.levelOverride;

					}

					c.level = level === 'hidden' ? 2 : parseInt( level );

				}

				c.keywords = this.currentInfo.keywords || 0;

			}

			return c;

		},
		selectedByLevel () {

			if ( !this.selected[this.level] ) return { keywords: 0 };

			return this.selected[this.level];

		},

		is () {

			let s = {
				firstTime: this.firstTime,
				trialing: this.trialing,
				public: this.isPublic,
				keywords: {
					currentSelected: !!this.current.keywords && this.selectedByLevel.keywords === this.current.keywords && this.current.level === this.level,
					has: this.current.keywords > 0
				},
				user: {
					new: !!this.newUser
				},
				level: {
					0: this.level === 0,
					1: this.level === 1,
					2: this.level === 2,
					3: this.level === 3
				},
				stripe: {
					trial: this.current.stripe.subscriptionStatus === 'trialing',
					cancelled: !!this.current.stripe.cancelled,
					pastDue: this.current.stripe.subscriptionStatus === 'past_due',
					setup: !!this.current.stripe.subscriptionStatus
				}
			};

			s.user.canTrial = ( !s.user.new && !s.public ) ? false : ( this.keywordCount[this.level] || 250 ) <= 500;

			return s;

		},

		slider () {

			let s = {
				data: [],
                range: [],
                rangeMobile: []
			};

			if ( this.products.keywords ) {

				this.products.keywords.forEach ( function (product,i) {

					if ( ( product.hidden && ( !this.currentInfo._id || this.currentInfo._id !== product._id ) ) || product.keywords > 10000 ) return;

					let price = product.prices.find( p => p.level === this.level && p.frequency === 'month' && ( !p.hidden || this.currentInfo.plan === p._id ) );
					
					if ( price ) {

						let p = Object.assign({}, product);

						p.month = price;

						p.year = product.prices.find( p => p.level === this.level && p.frequency === 'year' && !p.hidden );

						s.data.push(p.keywords);
						s.range.push(p);
						let p2 = Object.assign({}, p);
						p2.isHide = i%2 > 0;
						s.rangeMobile.push(p2);

					}

				}.bind(this));

			}

			return s;

		},

		responseMsgProcessed () {
			
			if ( this.is.stripe.pastDue ) {

				return 'Your payment could not be processed, please click here to try again.';

			}

			return this.responseMsg;

		},

		title() {

			if ( this.is.firstTime ) return "Welcome to RankCaddy!";

			return 'Hey ' + this.firstName;

		},

		subscribeBtn () {

			if ( this.is.public ) return 'Get Started';

			let default1 = this.is.user.canTrial ? 'Switch Trial To This' : 'Start Subscription';

			if ( this.canReverseOrCancel ) {

				let d = this.selectedFrequency ? this.selectedFrequency.charAt(0).toUpperCase() + this.selectedFrequency.slice(1) + 'ly' : null;

				if ( this.is.keywords.currentSelected && d ) {

					if ( this.currentInfo.frequency === this.selectedFrequency ) {

						return 'Current Subscription';

					}

					return 'Switch To ' + d;

				}

				if ( Object.keys( this.currentInfo ).length > 0 && d ) {

					if ( this.currentInfo.keywords > this.selectedByLevel.keywords ) {

						if ( this.currentInfo.frequency === this.selectedFrequency ) {

							return 'Downgrade';

						}

						return 'Downgrade &amp; Switch To ' + d;

					}
					else {

						if ( this.currentInfo.frequency === this.selectedFrequency ) {

							if (  this.currentInfo.keywords === this.selectedByLevel.keywords ) {

								return this.level > this.currentInfo.level ? 'Upgrade' : 'Downgrade';

							}

							return 'Upgrade';

						}

						return 'Upgrade &amp; Switch To ' + d;

					}

				}

			}

			if (!this.canReverseOrCancel && this.is.keywords.currentSelected ) {

				if ( this.is.trialing ) return 'Enter card details';
				
				if ( this.currentSubscription===this.selectedFrequency ) return 'Re-Start Subscription';

			}

			return default1;

		},

		showSubscribeButton () {

			if ( this.is.trialing && !this.is.stripe.trial ) return true;

			if ( !this.canReverseOrCancel || this.is.public ) return false;

			return !(( this.is.keywords.currentSelected && this.currentSubscription===this.selectedFrequency) );

		},

		canReverseOrCancel () {

			if ( this.is.stripe.cancelled ) {

				return !!this.stripe.paymentMethod;

			}

			return !this.is.trialing || this.is.stripe.trial;

		},

		currentCount () {

			return Object.keys( this.currentInfo ).length > 0 ? this.currentInfo.keywords : 0;

		},

		subscriptionAndCardDetailsEntered () {

			return this.is.keywords.has && ( !this.is.trialing || this.is.stripe.trial );

		},

		selectedLabel () {

			let dataDive = this.selectedByLevel.keywords / 50,
				max = 100;

			if ( dataDive > max ) dataDive = max;

			return this.numberWithCommas(this.selectedByLevel.keywords) + ' Daily Keywords' + ( ' | ' + this.numberWithK(dataDive) + ' Data Dive Domains' );

		},

		selectedLabelWeekly () {

			let perWeek = ( this.selectedByLevel.keywords * 30 ) / 4.34524;

			return this.numberWithCommas(Math.round(perWeek));

		},

		selectedProductName () {

			return this.selectedByLevel.labelFull;

		},

		selectedLabelMonthly () {

			let perMonth = this.selectedByLevel.keywords * 30;

			return this.numberWithCommas(Math.round(perMonth));

		},
		currentSubscription () {

			return this.currentInfo ? this.currentInfo.frequency : false;

		},
		endDate () {

			if ( !!this.trialExpires) {

				return this.formatDate( this.trialExpires );

			}

			return this.formatDate( this.stripe.currentPeriodEnd );

		},
		cancelDate () {

			return this.formatDate( this.stripe.cancel );

		},
		cancelledDate () {

			return this.formatDate( this.stripe.cancelled );

		},
		noChargeUntilAfterTrial () {

			return ( this.is.trialing && this.selectedByLevel.keywords <= 500 );

		},
		currentProductName () {

			if ( this.currentInfo._id ) {

				let p = this.products.keywords.find( p => p._id === this.currentInfo._id );

				if ( p ) return p.labelFull;

			}

			return null;

		},
		nextProductName () {

			if ( this.currentInfo.next ) {

				let p = this.products.keywords.find( p => p._id === this.currentInfo.next._id );

				if ( p ) return p.labelFull;

			}

			return null;

		}

	},
	methods : {

		...mapMutations('general',['updateLoadingText','updateVar']),

		formatDate (d) {

			const currentYear = new Date().getFullYear(),
				y = parseInt( general.dateFormat( 'Y', d ) ),
				dateFormat = y === currentYear ? 'F jS' : 'F jS Y';

			return general.dateFormat( dateFormat, d );

		},

		watchVideo () {

			this.updateVar( { varName:'playVideo', info: 'content-and-keywords' } ); 
			this.updateVar( { varName:'showVideos', info: true } ); 

		},

		prep () {

			if ( Object.keys( this.products ).length > 0 ) {

				this.levels.forEach ( function (level) {

					if ( this.selected[level] ) return;

					this.selected[level] = { month: null, year: null };

					this.products.keywords.forEach ( function (product) {

						if ( product.hidden ) return;

						['month','year'].forEach ( function (frequency) {

							if ( this.selected[level][frequency] ) return;

							this.selected[level][frequency] = product.prices.find( price => price.level === level && price.frequency === frequency && !price.hidden );

						}.bind(this));

					}.bind(this));

				}.bind(this));

				this.updateLoadingText();
				
			}

		},

		sortPastDue () {

			if ( !this.is.stripe.pastDue ) return;

			this.updateLoadingText("One moment...");

			ApiService.get( 'subscription/past-due/' + this.stripe.subscription )
			.then( function(response) {

				this.updateLoadingText();
				this.retryIntent = true;
				this.paymentMethod = response.data.payment_method;
				this.intent = response.data;

			}.bind(this))
			.catch( function(err) {

				this.responseMsg = err.response.data.error;
				this.scrollToResponseMsg ();
				this.updateLoadingText();

			}.bind(this));

		},

		showAnalysisCreditsInfo (e) {

			if ( e ) e.stopPropagation();

			this.updateVar( { varName: 'showAnalysisCreditsHow', info: true} );

		},

		buyAnalysisCredits() {

			this.updateVar( { varName: 'buyAnalysisCredits', info: true} );

		},

		closeResponseMsg () {

			this.responseMsg = '';

		},

		scrollToResponseMsg () {

			if ( this.responseMsg !== '' ) VueScrollTo.scrollTo('#response-msg', 100, { offset: -150 } );

		},

		price(frequency) {

			if ( !this.selected[this.level] || !this.selected[this.level][frequency] ) return '';

			let amount = this.selected[this.level][frequency].amount

			if ( this.legacy && this.currentInfo.keywords === this.selectedByLevel.keywords && this.currentInfo.frequency === frequency ) {

				amount = this.currentInfo.amount;

			}

			amount /= 100;

			if ( frequency === 'year' ) {

				let amount2 = amount / 12;
				amount2 = Math.round( amount2 );

				let saving = ( ( this.selected[this.level].month.amount / 100 ) * 12 ) - amount;

				return { 
					month: this.currency + this.numberWithCommas( amount2 ), 
					year: this.currency + this.numberWithCommas( amount ),
					text: '/yr. ' + this.currency + this.numberWithCommas( saving ) + ' Saving'
				};

			}
			else {

				return { 
					cost: this.currency + this.numberWithCommas( amount ),
					text: '/mo'
				};

			}
			

		},

		numberWithCommas(x) {

			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

		},

		numberWithK(x) {

			x = parseInt(x);

			if ( x > 1000 ) {

				x = ( x / 1000 ) + 'K';

			}

			return x;

		},

		callbackRange (val) {
			
			this.selected[this.level] = val;

		},

		setupActionRequired (webhookInfo, userInfo) {

			this.paymentActionRequired ( webhookInfo, userInfo, 'setup-intent' );

		},
		paymentActionRequired ( webhookInfo, userInfo, type ) {

			this.updateLoadingText('One moment...');

			type = type || 'payment-intent';
			
			this.paymentCloseEvents = type === 'setup-intent' ? 
			[] : 
			[
				{ eventType: 'invoice.payment_succeeded', callback: 'paymentSucceeded' },
				{ eventType: 'invoice.paid', callback: 'paymentSucceeded' },
				{ eventType: 'payment_intent.payment_failed', callback: 'paymentFailed' }
			];

			general.loadUser ( ApiService, this, function () {

				ApiService.get( 'subscription/action-required/' + webhookInfo.id )
				.then( function( info ) {

					this.updateLoadingText();

					this.intent = info.data;
					
				}.bind(this))
				.catch( function(err) {

					this.updateLoadingText();
					this.responseMsg = err.response.data.error;
					this.scrollToResponseMsg ();

				}.bind(this));

			}.bind(this));

		},

		trialCardAdded () {

			this.paymentSucceeded( null, null, 'trial' );

		},

		setupIntentSucceeded ( webhookInfo, userInfo, type ) {

			this.updateLoadingText();
			this.responseMsg = "Thanks, your card details have been saved.";
			this.scrollToResponseMsg ();
			if ( userInfo ) this.updateUserData ( userInfo, true );

		},

		setupIntentFailed ( webhookInfo, userInfo, type ) {

			general.registerForUpdates( ApiService, this, events, 
			function (callback) { // init function

				callback(false); // let's go
				this.paymentCloseEvents = {};

			}.bind(this), 
			function (userInfo) { // Continue function
				
				this.updateUserData (userInfo);
				
			}.bind(this),
			function (userInfo) { // Failed function
				
				this.updateUserData (userInfo,true);
				this.updateLoadingText();
				this.responseMsg = "It looks like we are having an issue, please refresh the page.";
				this.scrollToResponseMsg ();

			}.bind(this), 
			function (userInfo) { // Complete function
				
				this.firstLoadUser = true;
				this.responseMsg = "";
				this.updateLoadingText();
				this.updateUserData ( userInfo, true );

			}.bind(this));

		},

		paymentSucceeded ( webhookInfo, userInfo, type ) {

			type = type || 'payment';

			this.responseMsg = "Your payment was successful.";

			switch (type) {

				case 'trial' :

					this.responseMsg = 'Thanks, your card details have been added.';

					break;

				case 'upgrade' :

					this.responseMsg = 'Thanks, your subscription has been updated.';

					break;

				break;

			}

			if (userInfo ) {

				this.firstLoadUser = true;
				this.updateUserData ( userInfo );

			}

			this.scrollToResponseMsg ();

			this.updateVar( { varName:'reloadAnalysisCredits', info: true } );

			setTimeout( function () {

				this.updateVar( { varName:'reloadAnalysisCredits', info: true } );

			}.bind(this), 2500 );

			if ( !userInfo ) {

				general.loadUser ( ApiService, this, function (userData) {

					this.firstLoadUser = true;

					this.updateUserData( userData );

				}.bind(this));

			}

		},

		upgradeSucceeded ( webhookInfo, userInfo ) {

			this.paymentSucceeded ( webhookInfo, userInfo, 'upgrade' );

		},

		paymentFailed ( webhookInfo, userInfo ) {

			if ( webhookInfo.eventType === 'setup_intent-setup_failed' ) {
				this.responseMsg = "Your card could not be authorized, please try again.";
			}
			else {
				this.responseMsg = "Your payment could not be completed, please try again.";
			}
			
			this.updateLoadingText();
			this.scrollToResponseMsg ();
			this.updateUserData ( userInfo, true );

		},

		closePayment(info) {
			
			this.paymentInfo = null;
			this.intent = null;
			this.trial = false;
			this.paymentMethod = null;
			this.closeResponseMsg();

			general.modalClose();
			
			if ( !info.closeOnly && Object.keys( this.paymentCloseEvents ).length > 0 || info.paymentCloseEvents ) {
 
				this.updateLoadingText(true);

				let events = info.paymentCloseEvents || this.paymentCloseEvents;

				general.registerForUpdates( ApiService, this, events, 
				function (callback) { // init function

					callback(false); // let's go
					this.paymentCloseEvents = {};

				}.bind(this), 
				function (userInfo) { // Continue function
					
					this.updateUserData (userInfo);
					
				}.bind(this),
				function (userInfo) { // Failed function
					
					location.reload();

				}.bind(this), 
				function (userInfo) { // Complete function
					
					this.firstLoadUser = true;
					this.responseMsg = "";
					this.updateLoadingText();
					this.updateUserData ( userInfo, true );

				}.bind(this));

				return;

			}

			if ( info.success ) {

				if ( info.userInfo ) {

					this.updateUserData ( info.userInfo, true );
					this.responseMsg = "Your card details have been saved.";

				}

			}
			else {

				general.cancelUpdateRegistration(this);
				this.paymentCloseEvents = {};

			}

		},
		selectFrequency (frequency) {

			if ( frequency === 'month' && this.currentSubscription === 'year' && !this.is.trialing ) return;
			this.selectedFrequency = frequency;
			if ( this.pulseFrequencies ) this.processPrice();

		},
		processPrice() {

			if ( !this.selectedFrequency ) {

				this.pulseFrequencies = true;
				this.$snotify.error("Please select Monthly or Yearly", "Billing");
				return;

			}

			let events;

			this.pulseFrequencies = false;

			this.trial = ( this.is.user.new && this.is.user.canTrial );

			if ( !this.is.keywords.has || !this.is.stripe.setup ) { // First payment

				this.updateLoadingText(true);

				this.paymentCloseEvents = this.trial ? 
				[
					{ eventType: 'setup_intent.requires_action', callback: 'setupActionRequired' },
					{ eventType: 'setup_intent.succeeded', callback: 'trialCardAdded' }
				] : 
				[
					{ eventType: 'setup_intent.requires_action', callback: 'setupActionRequired' },
					{ eventType: 'invoice.payment_succeeded', callback: 'paymentSucceeded' },
					{ eventType: 'invoice.paid', callback: 'paymentSucceeded' }
				];

				this.paymentInfo = { 
					price: this.selected[this.level][this.selectedFrequency]._id, 
					product: this.selected[this.level]._id 
				};

				this.amount = this.selected[this.level][this.selectedFrequency].amount / 100;

				this.paymentTitle = this.levelName[this.level] + ' ' + this.selected[this.level].label;

				this.paymentFrequency = this.selectedFrequency;

			}
			else {

				this.$dialog
					.confirm( 'Are you sure you want to change your subscription?', { okText: 'Yes please', cancelText: 'No',})
					.then(function() {

						this.updateLoadingText('One moment...');

						this.closeResponseMsg();

						let isUpgrade = this.currentInfo.keywords < this.selectedByLevel.keywords || this.currentSubscription !== this.selectedFrequency,
							notUpgradeEvents = [{ eventType: 'subscription_schedule.updated', callback: 'upgradeSucceeded' }];

						if ( this.selectedByLevel.keywords <= 500 && this.is.trialing ) {

							isUpgrade = false;
							notUpgradeEvents.push({ eventType: 'customer.subscription.updated', callback: 'upgradeSucceeded' });

						}

						events = isUpgrade ? 
						[
							{ eventType: 'invoice.payment_succeeded', callback: 'upgradeSucceeded' },
							{ eventType: 'invoice.paid', callback: 'upgradeSucceeded' },
							{ eventType: 'invoice.payment_action_required', callback: 'paymentActionRequired' },
							{ eventType: 'payment_intent.requires_action', callback: 'paymentActionRequired' },
							{ eventType: 'subscription_schedule.updated', callback: 'upgradeSucceeded' }
						] : 
						notUpgradeEvents

						general.registerForUpdates( ApiService, this, events, 
						function (callback) { // init function

							ApiService.post( 'subscription/upgrade-downgrade', { product: this.selected[this.level]._id, price: this.selected[this.level][this.selectedFrequency]._id } )
							.then( function() {

								callback(false);

							}.bind(this))
							.catch( function(err) {

								general.cancelUpdateRegistration(this);
								this.responseMsg = err.response.data.error;
								this.scrollToResponseMsg ();
								callback(true);

							}.bind(this));

						}.bind(this), 
						function (userInfo) { // Continue function
							
							this.updateUserData (userInfo);
							
						}.bind(this),
						function (userInfo) { // Failed function
							
							this.updateUserData (userInfo,true);
							this.updateLoadingText();
							this.responseMsg = "It looks like we are having an issue, please refresh the page.";
							this.scrollToResponseMsg ();

						}.bind(this), 
						function (userInfo) { // Complete function
						
							this.firstLoadUser = true;
							this.updateUserData ( userInfo );

						}.bind(this));

					}.bind(this))
					.catch(function(err) {
						console.log(err);
						this.updateLoadingText();

					}.bind(this));

			}

		},
		cancel () {

			let m = this.is.stripe.cancelled ? 'Are you sure you want to reverse your cancellation?' : 'Are you sure you want to cancel your subscription?', 
				action = this.is.stripe.cancelled ? 'post' : 'delete';

			this.$dialog
				.confirm( m, { okText: 'Yes', cancelText: 'No',})
				.then(function() {

					this.updateLoadingText('One moment...');
					this.closeResponseMsg();

					let events = ['customer.subscription.deleted','customer.subscription.updated'];

					general.registerForUpdates( ApiService, this, events, 
					function (callback) { // init function

						ApiService[action]( 'subscription' )
						.then( function( info ) {

							this.updateLoadingText();

							if ( info.data.cancelUpdates ) {

								callback(true);

							}
							else {

								callback(false);

							}

							this.responseMsg = info.data.msg;

						}.bind(this))
						.catch( function(err) {

							this.responseMsg = err.response.data.error;
							callback(true);

						}.bind(this));

					}.bind(this), 
					function (userInfo) { // Continue function
						
						this.updateUserData (userInfo);
						
					}.bind(this),
					function (userInfo) { // Failed function
						
						this.updateUserData (userInfo,true);
						this.updateLoadingText();
						this.responseMsg = "It looks like we are having an issue, please refresh the page.";
						this.scrollToResponseMsg ();

					}.bind(this), 
					function (userInfo) { // Complete function
						
						this.firstLoadUser = true;
						this.updateUserData (userInfo,true);

					}.bind(this));

				}.bind(this))
				.catch(function() {
					
					this.updateLoadingText();

				});

		},
		updateUserData (userInfo,refreshProductInfo) {

			if ( !userInfo ) return;
			
			if ( this.firstLoadUser || refreshProductInfo ) {

				if ( userInfo.productInfo ) {
					
					Vue.set( this, 'currentInfo', userInfo.productInfo );

					this.legacy = !!this.currentInfo.hidden;

					this.level = parseInt( this.currentInfo.level );

					this.keywordCount[this.level] = userInfo.productInfo.keywords;

					if ( this.currentInfo.frequency && this.firstLoadUser ) 
						this.selectedFrequency = this.currentInfo.frequency;

					Vue.set( this.selected, this.level, this.slider.range.find( p => p._id === this.currentInfo._id ) );

				}
				else {

					Vue.set( this, 'currentInfo', {} );

				}

			}

			this.firstLoadUser = false;

			Vue.set( this, 'stripe', userInfo.stripe );

			this.newUser = !!userInfo.newUser;

			this.trialing = !!userInfo.trialing;

			if ( this.trialing && ( !userInfo.stripe || !userInfo.stripe.subscription ) && !!userInfo.trial && !!userInfo.trial.expires ) {

				let trialExpires = new Date( userInfo.trial.expires ); 

				if ( trialExpires.getTime() > new Date().getTime() ) {

					this.trialExpires = trialExpires;

				}

			}

			this.firstTime = userInfo.firstTime;

			this.firstName = userInfo.firstName;

		},
		custom () {

			$crisp.push(["do", "chat:open"]);

		}

	},
	created() {

		this.updateLoadingText(true);

		this.levels.forEach( level => {

			Vue.set( this.selected, level, { keywords: 0 } );
			Vue.set( this.keywordCount, level, 0 );

		});

		this.prep ();

		if ( !this.is.public ) {

			general.loadUser ( ApiService, this, function (userData) {

				this.updateUserData( userData );

			}.bind(this));

		}
		
		ApiService.get( 'stripe/settings' )
		.then( function( info ) {

			Vue.set( this, 'currency', info.data.currency );

			this.fetchedSettings = true;

		}.bind(this))
		.catch( function(err) {
			console.log(err);
		}.bind(this));

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';
@keyframes border-pulsate {
    0%   { border-color: rgba(241, 73, 42, 1); }
    50% { border-color: rgba(241, 73, 42, 0); }
    100%   { border-color: rgba(241, 73, 42, 1); }
}
.video {

		display: flex;
		justify-content: left;
		align-items: center;
		margin-top: 20px;
		cursor: pointer;

		span {
			padding-left: 10px;
		}

		svg, span {
			display: inline-block;
		}

		svg {

			width: 50px;

			display: inline-block;

		}

	}
.current-info {
	margin: 0 0 10px;
	.orange {

		color: @formDefaultColour;
		font-weight: @bold;

	}
	.underline {
		
		text-decoration: underline;

	}
	.cursor {
		cursor: pointer;
	}
}
#response-msg {
	background-color: @formDefaultColour;
	color: #fff;
	padding: 10px;
	margin: 16px 0 10px;
	.rounded(10px);
	text-align: center;
	.vertical-align-parent;
	span {
		color: inherit;
	}
	.close {
		color: rgba(255,255,255,0.5);
		display: block;
		position:absolute;
		right: 10px;
		top: 10px;
		cursor: pointer;
		line-height: 1em;
		font-size: 0.8em;
		.vertical-align;
		.trans;
		&:hover {
			color: rgba(255,255,255,1);
		}
	}
	&.past-due {
		background-color: @red;
		cursor: pointer;
		.close {
			display: none;
		}
		&:hover {
			background-color: @formDefaultColour;
		}
	}
}

.form {

	.keyword-subscriptions-options-description {

		padding: 0;
		margin: 20px 0 0;

	}

	.keyword-subscriptions-options-levels {

		margin: 30px 0;

		> div {

			background-color: #fff;
			color: @darkContrast;
			padding: 20px;
			.rounded(10px);
			cursor: pointer;
			box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.15);
			position: relative;
			overflow: hidden;
			margin-bottom: 20px;
			.opacity(0.8);

			&:last-child {

				margin-bottom: 0;

			}

			span {

				&.current {

					border-radius: 0 0 5px 0;
					position: absolute;
					top: 0;
					background-color: #f1492a;
					color: #fff;
					font-size: 12px;
					padding: 1px 10px;
					z-index: 0;
					width: 80px;
					left: 0;
					text-align: center;

				}

			}

			h2, p {
				color:inherit;
				text-align: center;
				margin: 0;
			}

			p {
				font-size: 12px;
			}

			&.selected {

				background-color: @darkContrast;
				color: #fff;
				cursor: default;
				.opacity(1);

			}

			&:not(.selected) {

				&:hover {

					background-color: @formDefaultColour;
					color: #fff;

					span {

						&.current {

							background-color: #fff;
							color: @formDefaultColour;

						}

					}

				}

			}

			&.custom {

				background-color: #fff;
				color: @darkContrast;

				&:hover {

					background-color: @formDefaultColour;
					color: #fff;

				}

			}

		}

	}

	.new-user-panel {

		margin-bottom: 15px;
		text-align: center;

		h3, p {
			margin: 0;
			padding: 0;
			strong {
				font-weight: @bold;
			}
		}

		h3 {

			color: @formDefaultColour;
			font-size: 26px;

		}

		p {
			margin-top: 10px;
		}

		.large-button {

			background-color:@formDefaultColour;
			color: #fff;
			margin-left: auto;
			margin-right: auto;
			margin-bottom: 5px;

			&.greyed {

				background-color:#000;
				.opacity(0.2);

			}

			&:not(.greyed) {

				&:hover {

					background-color: #000;

				}

			}

		}

	}

	> .new-user-panel {

		margin: 20px 10px 25px;

	}

	.form-inputs-section {

		background-color: #f7f7f7;

		 .form-inputs-section-title {

			position: relative;

			.whats-this {

				font-size: 0.5em;
				position: absolute;
				padding-left: 10px;
				padding-top: 10px;
				cursor: pointer;

				&:hover {

					text-decoration: underline;

				}

			}

		 }

		.selected-label {

			text-align: center;
			color: @formDefaultColour;
			text-transform: uppercase;
			position: relative;

			.frequency-info {

				display: inline-block;
				width: 100%;
				font-size:0.5em;
				color:@darkContrast;
				text-transform: none;

			}

		}

		.slide-wrap {

			padding: 0 5px;

			&.desktop {

				display: none;

			}

		}

		&.analysis-credits {

			.overview {

				margin:0 0 26px;
				text-align: center;

				.large-button {

					min-width: 160px;
					font-weight: @bold;
					margin-right: 20px;
					margin-top: 20px;

					&:last-child {

						margin-right: 0;

					}

				}

			}

			.purchases {

				.purchase {

					display: inline-block;
					background-color: #fff;
					.rounded(10px);
					padding: 12px;
					margin: 0 15px 15px 0;
					min-width: 170px;

					.credits {

						font-size: 1.5em;
						font-weight: @bold;
						background-color: @formDefaultColour;
						color: #fff;
						.rounded(5px);
						text-align: center;
						position: relative;
						display: inline-block;
						padding: 0 6px;
						min-width: 56px;

						&:after {
							content: "Credits Remaining";
							position: absolute;
							display: block;
							color: @darkContrast;
							.font-standard;
							font-weight: normal;
							text-align: left;
							left: 100%;
							font-size: 0.5em;
							top: 4px;
							line-height: 1.1em;
							padding-left: 6px;
						}

						&.not1 {
							&:after {

								content: "Credits Remaining";

							}
						}

					}

					.type {

						margin-top: 8px;

					}

					.type, .expires {

						text-align: center;
						font-size: 14px;
						padding: 0 4px;

						&.monthly, &.subscription {

							color: @formDefaultColour;

						}

					}

					.expires {

						font-weight: normal;
						border-top: 1px solid @darkContrast;
						margin-top: 2px;
    					padding-top: 2px;

					}

				}

			}

		}

	}
	.cancel-panel {

		text-align: center;

		p {

			font-size: 12px;
			max-width: 600px;
			margin: 30px auto 0;

		}

	}
	.selected {

		.trial {

			text-align: center;
			position: relative;

			p {

				font-size: 20px;
				text-align: center;
				margin: 15px 0 0;

				strong {

					color:@formDefaultColour;

				}

				&.small {

					font-size: 18px;

				}

			}

			.large-button {

				width: 100%;
				max-width: 400px;
				font-size: 24px;

			}

			&.greyed {

				cursor: not-allowed;

				&:after {

					content: "";
					left: 0;
					top: 0;
					bottom: 0;
					right: 0;
					position: absolute;
					display: block;
					z-index: 3;

				}

				&:before {

					content: "Not available for this many keywords";
					left: 0;
					top: 50%;
					margin-top: -15px;
					bottom: 0;
					font-size: 20px;
					right: 0;
					position: absolute;
					display: block;
					z-index: 3;

				}

				p {

					.opacity(0.2);

					strong {

						color:@darkContrast;

					}

				}

				.large-button {

					.opacity(0.3);

				}

			}

		}

		.options {

			margin-top: 50px;
			text-align: center;

			.line {

				display: none;

			}

			.option {

				text-align: center;
				display: inline-block;
				width: 44%;
				margin: 0 3%;
				padding: 15px;
				cursor: pointer;
				border: 3px solid transparent;
				.rounded(10px);
				background-color: #fff;
				position: relative;

				&:not(.disabled):hover, &:not(.disabled).selected {

					border-color: @formDefaultColour;

				}

				&.disabled {

					cursor: not-allowed;
					padding-top: 20px;

					&:after {
						content: "Current";
						display: block;
						position: absolute;
						width: 100%;
						text-align: center;
						left: 0;
						top: 0;
						font-size: 16px;
						font-weight: @bold;
						color: @formDefaultColour;
					}

					&.legacy {

						&:after {
							
							content: "Current (Legacy)";

						}

					}

					&.selected {

						border-color: @darkContrast;

					}

					&.disabled2 {

						.vertical-align-parent;

						.info-title, .info-price, .info-price-info {

							.opacity(0.15);

						}

						&:after {

							content: "A yearly subscription cannot be changed to a monthly one.";
							padding: 20px;
							box-sizing: border-box;
							.vertical-align;

						}

					}

				}

				&.pulseIt {

					animation: border-pulsate 2s infinite;

				}

				.info-title {

					font-size: 22px;

				}

				.info-price {

					font-weight: normal;
					font-size: 32px;
					margin-top: 12px;
					position: relative;
					padding-bottom: 0;

				}

				.info-price-info {

					font-size: 16px;
					.opacity(0.5);
					padding: 0;
					margin: 0

				}

			}

			.large-button {

				width: 100%;
				background-color:@formDefaultColour !important;
				color: #fff;
				max-width: 400px;
				font-size: 24px;
				text-decoration: none;

				&.dropText {

					position: relative;
					overflow: visible;
					display: block;
					margin-bottom: 20px;
					margin-left: auto;
					margin-right: auto;

					&:before {

						content: "Cancel before the end of your trial and you will not be charged.";
						position: absolute;
						bottom: -38px;
						z-index: 2;
						display: block;
						text-align: center;
						font-size: 12px;
						width: 100%;
						left: 0;
						color: @textGrey;
 
					}

				}

				&:hover {

					background-color:@darkContrast !important;
					text-decoration: none;

				}

			}

		}

	}

	&.public {

		h1, h2, h3, h4, h5, p, span, a {

			font-family: Nunito,sans-serif;

		}

		.form-inputs-section {

			background-color: #fff;
			box-shadow: none;

		}

	}
}

@media screen and (min-width: 414px) {

	.form {
		.selected {
			.options {
				.option {
					.info-price {

						font-size: 40px;

					}

				}

			}

		}

	}

}

@media screen and (min-width: 660px) {

	.form {

		position: relative;

		.keyword-subscriptions-options-levels {

			display: flex;

			> div {

				width: 33%;
				margin: 0 30px 0 0;

				&:last-child {

					margin-right: 0;

				}

				p {

					max-width: 300px;
					margin: 0 auto;

				}

			}

		}

		.form-inputs-section {

			&.panel {

				&.tabbed {

					position: relative;
					width: 100%;

					> .form-inputs-section-title {

						position: absolute;
						background-color: inherit;
						padding: 6px 12px;
						border-radius: 5px 5px 0 0;
						top: -40px;
						left: 0;
						text-align: center;
						width: 192px;

						.whats-this {

							position: relative;
							display: inline-block;
							vertical-align: top;
							padding-top: 4px;
							color: inherit;

						}

					}

					&.analysis-credits {

						> .form-inputs-section-title {

							width: 295px;
							left: 205px;

						}

					}

					&.selected-tab {

						margin-top: 50px;
						z-index: 2;
						min-height: 100px;

						> .form-inputs-section-title {

							top: -40px;

						}

					}

					&:not(.selected-tab) {

						padding: 0;
						position: absolute;
						top: 0;
						z-index: 1;

						> .form-inputs-section-title {

							.opacity(0.6);
							cursor: pointer;
							background-color: @formDefaultColour;
							color: #fff;
							.trans(opacity 0.25s linear);
							padding-bottom: 30px;

							&:hover {

								.opacity(1);

							}

						}

						.form-inputs-section-inner {

							display: none;

						}

					}

				}

			}

		}

	}

}

@media screen and (min-width: 768px) {

	.form {

		.selected {

			.options {

				.option {

					.info-price {

						font-size: 44px;

					}

				}

			}

			.trial {

				p {

					margin-top: 40px;

				}

			}

		}

		.new-user-panel {

			h3 {

				font-size: 30px;

			}

		}

		.form-inputs-section {

			.slide-wrap {

				padding: 0 20px;

				&.desktop {

					display: block;

					.vue-slide-bar-component {

						min-height: 74px;
    					padding-top: 34px;

					}

				}

				&.mobile {

					display: none;

				}

			}

			.selected-label {

				.frequency-info {

					left: 0;
					top: 2.8em;
					position: absolute;

				}

			}

			&.analysis-credits {

				position: relative;

				.overview {

					text-align: right;
					margin: 0;
					position: absolute;
					right: 15px;
					top: 0;

				}

				.purchases {

					margin-top: 50px;

				}

			}
				
		}

	}

}
@media screen and (min-width: 1024px) {

	.form {

		.new-user-panel {

			max-width: 1000px;
			margin: 10px 0;
			text-align: left;

		}

		> .new-user-panel {

			margin-bottom: 30px;

		}

		.form-inputs-section {

			&.panel {

				padding-top: 10px;

				&.tabbed {

					> .form-inputs-section-title {

						top: 0;

					}

					&.selected-tab {

						margin-top: 40px;

					}

					&:not(.selected-tab) {

						> .form-inputs-section-title {

							&:hover {

								top: -10px;

							}

						}

					}

				}

			}

			&.analysis-credits {

				.purchases {

					margin-top: 60px;

				}

			}

		}

		.selected {

			text-align: center;
			margin-top: 22px;

			.options, .trial {

				display: inline-block;
				vertical-align: top;
				width: 92%;
				margin: 0 4%;
				max-width: 500px;
				position: relative;
				
				&.hasButton {

					min-height: 315px;

				}

				.large-button {

					width: 100%;
					max-width: none;
					font-size: 24px;
					position: absolute;
					bottom: 0;
					left: 0;

				}

			}

			.trial {

				p {

					margin-top: 20px;

				}

			}

			.options {

				padding-top: 10px;
				position: relative;

				.line {

					width: 1px;
				    height: 200px;
				    left: -10%;
				    top: 10%;
				    background: #dadada;
				    position: absolute;
				    display: block;

				    &:after {
					  position: absolute;
					  content: "";
					  height: 30%;
					  width: 100%;
					  top: 0;
					  left: 0;
					  background: linear-gradient(#f7f7f7 0%, transparent 100%);
					}

					&:before {
					  position: absolute;
					  content: "";
					  height: 30%;
					  width: 100%;
					  bottom: 0;
					  left: 0;
					  background: linear-gradient(transparent 0%, #f7f7f7 100%);
					}

				}

				.option {

					padding: 35px 0;

					.info-price {

						font-size: 3.2vw;
						padding-bottom: 0;

					}

					.info-price-info {

						font-size: 20px;

					}

					&.disabled {

						&:after {

							top: 1%;

						}

					}

				}

			}	

		}

	}

}

@media screen and (max-width: 1200px) {

	.form {

		.keyword-subscriptions-options-levels {

			> div {

				p {

					br {
						display: none;
					}

				}

			}

		}

	}

}

@media screen and (min-width: 1280px) {

	.form {

		.selected {
			.options.hasButton, .trial.hasButton {
				min-height: 300px;
			}
			.options {

				.option {

					.info-price {

						font-size: 50px;

					}

				}

			}
			.trial {
				
				&.greyed {

					&:before {

						display: none;

					}

					&:hover {

						&:before {

							display: block;

						}

					}

				}

			}

		}

		.keyword-subscriptions-options-levels {

			display: block;
			width: 360px;
			padding-right: 30px;
			margin: 36px 0;

			> div {

				width: 100%;
				margin-bottom: 20px;

			}

		}

		.form-inputs-section {

			.form-inputs-section-inner {

				.keyword-subscriptions-options-wrap-wrap {

					display: flex;

				}

				.keyword-subscriptions-options-wrap {

					flex-grow: 1;
					margin-top: 0;

				}

			}

		}

	}

}
</style>